import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import { getUnlocodeFromRouteCode } from '../../Utils/unlocode-mapper'

export function useRoutes() {
  const { state } = useTravelSearchContext()
  const { routesApiData, selectedRoute } = state

  const routeCode = selectedRoute?.routeCode ?? routesApiData?.defaultRoute?.routeCode ?? routesApiData?.categories[0]?.routes[0]?.routeCode

  const selectedUnloCode = getUnlocodeFromRouteCode(routeCode ?? '')

  return {
    routesApiData,
    selectedRoute,
    selectedUnloCode,
    isRoutesLoading: state.routesApiLoading ?? !routesApiData,
  }
}
